import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonComponent,
  DropdownTriggerDirective,
  scaleAnimation,
  SvgIconComponent,
} from '@ui-lib/components';
import { UserInformationService } from '../../../core/services/user/user-information.service';
import { defer, Observable, of, shareReplay } from 'rxjs';
import { CurrentUserInfo } from '../../../core/services/user/user-information.model';
import { AuthService } from '../../../core/services/auth/auth.service';

@Component({
  standalone: true,
  selector: 'mon-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  imports: [
    SvgIconComponent,
    DropdownTriggerDirective,
    TranslateModule,
    ButtonComponent,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [scaleAnimation],
})
export class AccountComponent {
  private readonly authService = inject(AuthService);
  private readonly userInformationService = inject(UserInformationService);

  @Input()
  public collapsed = false;

  public readonly userInfo$: Observable<CurrentUserInfo | null | undefined> = defer(() =>
    this.authService.hasValidAccessToken()
      ? this.userInformationService.getCurrentUser()
      : of(null),
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  public logout(): void {
    this.authService.logout();
  }
}
